import dayjs from "dayjs";

export const formatDatetime = (
  str: string,
  timeFormat = "HH:mm"
): string => {
  return dayjs(str).format(`YYYY/MM/DD ${timeFormat}`);
};
